// extracted by mini-css-extract-plugin
export var icon = "questions-answers-list-module--icon--zFgjR";
export var list = "questions-answers-list-module--list--ZveNp";
export var question = "questions-answers-list-module--question--qlFWs";